import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  sliderWrapper: {
    width: '100%',
    '& .swiper-button-next': {
      color: '#fff',
    },
    '& .swiper-button-prev': {
      color: '#fff',
    },
  },
  imgContainer: {
    width: '100%',
    height: `calc(100vh - ${
      theme.palette.custom.captionHeaderHeight +
      theme.palette.custom.headerHeight
    }px)`,
    [theme.breakpoints.down('sm')]: {
      height: 240,
    },
  },
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}))

export default useStyles
